import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import "./CurrentMedications.css"

const CurrentMedicationsList = ({ ...props }) => {
  const startDateFormatter = (cell, row) => {
    return `${moment(row.startDate).format("MM/DD/YYYY")}`;
  };
  const endDateFormatter = (cell, row) => {
    return row?.isForever ? 'Forever' : `${moment(row.endDate).format("MM/DD/YYYY")}`;
  };
  const srNumberFormatter = (cell, row, rowIndex) => {
    if (props.currentPage > 1)
      return <>{props.perPage * (props.currentPage - 1) + (rowIndex + 1)}</>;
    else return <>{rowIndex + 1}</>;
  };
  const prescribingDoctorFormatter = (cell, row) => {
    return (<>
      <span> {row?.doctor?.firstName}</span>
      <span style={{ padding: "8px" }}>{row?.doctor?.lastName}</span>
    </>)

  }
  const dispensingPharmacyFormatter = (cell, row) => {
    return (<>
      <span> {row?.pharmacist?.firstName}</span>
      <span style={{ padding: "8px" }}>{row?.pharmacist?.lastName}</span>
    </>)

  }
  const columns = [
    {
      dataField: "id",
      text: "No.",
      formatter: srNumberFormatter,
      headerStyle: () => {
        return { width: "48px" };
      },

    },
    {
      dataField: "medicationName",
      text: "MEDICATION NAME",
    },
    {
      dataField: "route",
      text: "ROUTE"
    },
    {
      dataField: "form",
      text: "FORM",
    },
    {
      dataField: "numberOfDoses",
      text: "NUMBER OF DOSES",
      headerStyle: () => {
        return { width: "128px" };
      }
    },
    {
      dataField: "doctor",
      text: "PRESCRIBING DOCTOR",
      headerStyle: () => {
        return { width: "128px" };
      },
      formatter: prescribingDoctorFormatter
    },
    {
      dataField: "pharmacist",
      text: "DISPENSING PHARMACY",
      headerStyle: () => {
        return { width: "128px" };
      },
      formatter: dispensingPharmacyFormatter
    },
    {
      dataField: "frequencyText",
      text: "FREQUENCY",
    },
    {
      dataField: "startDate",
      text: "START DATE",
      formatter: startDateFormatter,
      headerStyle: () => {
        return { width: "180px" };
      }
    },
    {
      dataField: "endDate",
      text: "END DATE",
      formatter: endDateFormatter,
      headerStyle: () => {
        return { width: "180px", paddingLeft: "14px" };
      }
    },
    {
      dataField: "remainingQuantity",
      text: "REMAINING QUANTITY",
      headerStyle: () => {
        return { width: "128px" };
      }
    },
    {
      dataField: "allowableRefills",
      text: "ALLOWABLE REFILLS",
      headerStyle: () => {
        return { width: "128px" };
      }
    }
    //  {
    //   dataField: "notes1",
    //   text: "NOTES",
    //   formatter: notesFormatter,
    //   events: {
    //     onClick: (e, column, columnIndex, row, rowIndex) => {
    //       handleShowNotesModal(true, row);
    //     }
    //   },
    // },
  ];
  const defaultSorted = [{
    dataField: 'startDate',
    order: 'desc'
  }];
  
  return (
    <BootstrapTable
      keyField="id"
      wrapperClasses="drilldown-list-table-wrapper"
      classes="drilldown-list-table drilldown-list-table--medications"
      data={props.CurrentMedicationList?.length ? props.CurrentMedicationList.sort((t1, t2) => {
        if (t1.startDate > t2.startDate) return -1;
        if (t1.startDate < t2.startDate) return 1;
        return 0;
      }) : []}
      columns={columns}
      striped
      hover
      condensed
      bordered={false}
      defaultSorted={defaultSorted}
      noDataIndication="No medications found for the selected date range."
    />
  );
};

export default CurrentMedicationsList;
